var map = {
	"./brands/bose-logo.avif": 4249,
	"./brands/jbl-logo.webp": 8702,
	"./brands/sennheiser-logo.webp": 3637,
	"./brands/sony-logo.webp": 5450,
	"./carousel/hero_earbuds.webp": 9774,
	"./carousel/hero_headphones.webp": 6693,
	"./carousel/hero_speakers.webp": 3278,
	"./categories/earbuds.webp": 1035,
	"./categories/headphones.webp": 5840,
	"./categories/speakers.webp": 6817,
	"./dropdown/customer_pick.webp": 5336,
	"./dropdown/gift_card.webp": 531,
	"./dropdown/sales.webp": 7797,
	"./earbuds_section/earbuds_1.webp": 3545,
	"./earbuds_section/earbuds_2.webp": 1150,
	"./earbuds_section/earbuds_3.webp": 6415,
	"./earbuds_section/earbuds_4.webp": 4390,
	"./logo_black.webp": 1579,
	"./logo_white.webp": 2689,
	"./payment_systems/amex.svg": 5552,
	"./payment_systems/diners_club.svg": 4775,
	"./payment_systems/discover.svg": 7672,
	"./payment_systems/mastercard.svg": 2321,
	"./payment_systems/paypal.svg": 4868,
	"./payment_systems/visa.svg": 2080,
	"./product_services/security.svg": 3437,
	"./product_services/shipping.svg": 9240,
	"./product_services/support.svg": 5795,
	"./products/earbuds_1.webp": 6351,
	"./products/earbuds_2.webp": 6899,
	"./products/earbuds_3.webp": 7119,
	"./products/earbuds_4.webp": 5759,
	"./products/earbuds_5.webp": 9334,
	"./products/earbuds_6.webp": 9881,
	"./products/headphones_17_blue.webp": 8703,
	"./products/headphones_17_green.webp": 3856,
	"./products/headphones_17_pink.webp": 7221,
	"./products/headphones_17_red.webp": 9548,
	"./products/headphones_17_white.webp": 5333,
	"./products/headphones_17_yellow.webp": 4495,
	"./products/headphones_18.webp": 5070,
	"./products/headphones_19.webp": 6916,
	"./products/headphones_20.webp": 5732,
	"./products/headphones_21.webp": 7348,
	"./products/headphones_22.webp": 309,
	"./products/headphones_23.webp": 1213,
	"./products/headphones_24_clementine.webp": 2919,
	"./products/headphones_24_grey.webp": 9223,
	"./products/headphones_24_light_brown.webp": 9627,
	"./products/headphones_24_yellow.webp": 9724,
	"./products/headphones_25.webp": 8152,
	"./products/headphones_26.webp": 4910,
	"./products/headphones_27.webp": 3113,
	"./products/headphones_28.webp": 7032,
	"./products/headphones_29.webp": 6652,
	"./products/headphones_30.webp": 694,
	"./products/headphones_31.webp": 3595,
	"./products/headphones_32.webp": 1657,
	"./products/headphones_33.webp": 4008,
	"./products/headphones_34.webp": 2138,
	"./products/headphones_35.webp": 9759,
	"./products/headphones_36.webp": 7812,
	"./products/headphones_37.webp": 6471,
	"./products/headphones_38.webp": 8470,
	"./products/speakers_10.webp": 1003,
	"./products/speakers_11.webp": 6174,
	"./products/speakers_12.webp": 2999,
	"./products/speakers_12_green.webp": 16,
	"./products/speakers_12_orange.webp": 7087,
	"./products/speakers_12_yellow.webp": 3229,
	"./products/speakers_13.webp": 2332,
	"./products/speakers_14.jpg": 67,
	"./products/speakers_15_dark_green.webp": 6668,
	"./products/speakers_15_dark_grey.webp": 553,
	"./products/speakers_15_grey.jpg": 5949,
	"./products/speakers_15_red.webp": 9698,
	"./products/speakers_15_sand.webp": 6851,
	"./products/speakers_15_soft_pink.webp": 3190,
	"./products/speakers_15_teal.webp": 8542,
	"./products/speakers_15_white.webp": 7198,
	"./products/speakers_15_yellow.webp": 1775,
	"./products/speakers_16.webp": 7366,
	"./products/speakers_7.webp": 3555,
	"./products/speakers_8.webp": 6705,
	"./products/speakers_9.webp": 3900,
	"./socials/facebook_logo.svg": 5553,
	"./socials/instagram_logo.svg": 4054,
	"./socials/pinterest_logo.svg": 7493,
	"./socials/tiktok_logo.svg": 4126,
	"./socials/twitter_logo.svg": 7750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;